import React from "react";
import { CircularProgress } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useData } from "../providers/DataProvider";
import CustomizerCart from "../components/CustomizerCart";
import CustomizerOverlay from "../components/CustomizerOverlay";
import ShopifyCreateCheckout from "../utils/ShopifyCreateCheckout";
import ShopifyGetProductVariant from "../utils/ShopifyGetProductVariant";
import { getMiscLineItems } from "../utils/CheckoutHelpers";
import useCheckout from "../hooks/useCheckout";

export default function Cart() {
  const data = useData();
  const {
    previousCartLineItems,
    lastIncompleteCheckout,
    setPreviousCartLineItems,
    checkoutLoading,
  } = useCheckout(data.customer);
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = React.useState(false);

  // Check if the customer had an existing cart on Shopify.
  React.useEffect(() => {
    if (searchParams.get("cartItems")) {
      const items = JSON.parse(searchParams.get("cartItems"));
      items.forEach((item) => {
        ShopifyGetProductVariant(item.variant).then((variant) => {
          const lineItem = getMiscLineItems([
            {
              ...variant,
              quantity: item.quantity,
            },
          ]);
          setPreviousCartLineItems((items) => items.concat(lineItem));
        });
      });
    }
  }, []);

  const handleCheckout = React.useCallback(() => {
    setLoading(true);
    ShopifyCreateCheckout(
      data.token,
      previousCartLineItems,
      lastIncompleteCheckout.customAttributes,
      data.isKiosk
    ).then((checkout) => {
      if (checkout) {
        window.location.assign(checkout.checkoutUrl);
      }
    });
  }, [data.token, previousCartLineItems, lastIncompleteCheckout?.customAttributes]);

  const handleContinueShopping = React.useCallback(() => {
    setLoading(true);
    ShopifyCreateCheckout(
      data.token,
      previousCartLineItems,
      lastIncompleteCheckout.customAttributes
    ).then((checkout) => {
      if (!data.token) {
        window.location.assign(`https://${process.env.REACT_APP_SHOP_URL}/pages/choose-your-style`);
      } else {
        window.location.assign(
          `https://${process.env.REACT_APP_SHOP_URL}/account/login/multipass/${checkout.multipassToken}`
        );
      }
    });
  }, [data.token, previousCartLineItems, lastIncompleteCheckout?.customAttributes]);

  if (loading || checkoutLoading) {
    return (
      <CustomizerOverlay>
        <CircularProgress />
      </CustomizerOverlay>
    );
  }

  return (
    <CustomizerCart
      previousCart={previousCartLineItems}
      setPreviousCartLineItems={setPreviousCartLineItems}
      handleCheckout={handleCheckout}
      handleContinueShopping={handleContinueShopping}
      setLoading={setLoading}
      lastIncompleteCheckout={lastIncompleteCheckout}
      isKiosk={data.isKiosk}
    />
  );
}
